import { useEffect, useState } from 'react'
import { authedAxios } from '../../utils'
import {
  updateObjectAtIndex,
  updateObjectWithMatchingId,
} from '../../utils/array'
import useAlert from '../useAlert'
import useGenericEndpoint from './useGenericEndpoint'

const useCards = (pipelineId, filters) => {
  const url = `/api/pipeline/${pipelineId}/cards`

  const shouldDelayCall = !pipelineId

  const { data, isLoading, hasLoadError } = useGenericEndpoint(url, {
    filters,
    shouldDelayCall,
  })

  const { createGenericErrorAlert } = useAlert()

  const [cards, setCards] = useState([])

  useEffect(() => {
    if (!data || isLoading || hasLoadError) return

    setCards(data.cards)
  }, [data, isLoading, hasLoadError])

  const moveCardLocally = (card, stageId) => {
    const index = cards.indexOf(card)
    const newCard = { ...card, stageId }
    setCards(updateObjectAtIndex(cards, newCard, index))
  }

  const updateCard = (newVal) => {
    setCards(updateObjectWithMatchingId(cards, newVal, false))
  }

  const moveCard = (card, stageId) => {
    moveCardLocally(card, stageId)
    return authedAxios
      .put(`/api/pipeline/${pipelineId}/cards/${card.id}/stages/${stageId}`)
      .catch(() => {
        moveCardLocally(card, card.stageId)
        createGenericErrorAlert()
      })
  }

  return { cards, isLoading, hasLoadError, moveCard, updateCard }
}

export default useCards
